import { render, staticRenderFns } from "./SearchHtml.vue?vue&type=template&id=2c67355a&"
import script from "./SearchHtml.vue?vue&type=script&lang=js&"
export * from "./SearchHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports